(function () {
  window.MAKIA_TRANSLATIONS = window.MAKIA_TRANSLATIONS || {};

  // German translations. Inner <span rivo-x-text="..."> placeholders MUST be
  // kept intact — Rivo fills them with live customer data (name, points, tier).

  window.MAKIA_TRANSLATIONS.de = {

    rivo_lp_translation: {
      loyalty_page_ways_to_earn_title: 'Punkte sammeln',
      loyalty_page_ways_to_earn_subtitle: 'Sammle Punkte mit jedem Einkauf sowie durch das Abschließen dieser Aktivitäten.',
      loyalty_page_ways_to_redeem_title: 'Punkte einlösen',
      loyalty_page_ways_to_redeem_subtitle: 'Löse Punkte für diese Prämien ein:',
      loyalty_page_vip_tiers_logged_out_title: 'Prämienstufen',
      loyalty_page_vip_tiers_logged_out_subtitle: 'Tritt unserem Prämienprogramm bei und schalte exklusive Vorteile frei.',
      loyalty_page_vip_tiers_logged_in_title: 'Prämienstufen',
      loyalty_page_vip_tiers_logged_in_subtitle: 'Du befindest dich auf der <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.tier?.name">Bronze</span>-Stufe',
      loyalty_page_vip_tier_1_threshold_text: '0 Punkte',
      loyalty_page_vip_tier_2_threshold_text: '1500 Punkte',
      loyalty_page_vip_tier_3_threshold_text: '5000 Punkte'
    },

    translations: {
      account_dashboard_member_card_header_title: 'Willkommen <span rivo-x-data="" rivo-x-text="$store.customer?.first_name">Christa</span>',
      account_dashboard_member_card_body_title: 'Du hast <strong><span rivo-x-data="" rivo-x-text="$store.customer.pretty_points_tally">200</span></strong> Punkte',
      account_dashboard_member_card_body_subtitle: 'Du bist auf der <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.tier?.name">Bronze</span>-Stufe',
      account_dashboard_member_card_cta_text: 'Prämien ansehen',
      account_dashboard_rewards_progress_block_subtitle: 'Sammle weitere <span rivo-x-data="" rivo-x-text="$store.customer.pretty_points_amount_to_next_reward">300</span> Punkte, um die Prämie <span rivo-x-data="" rivo-x-text="$store.customer.next_reward?.name">€5 off coupon</span> freizuschalten',
      account_dashboard_rewards_progress_block_completed_subtitle: 'Sammle weiter Punkte, um mehr Prämien freizuschalten',
      account_dashboard_vip_tiers_progress_subtitle: 'Sammle <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.next_tier?.formatted_to_spend_or_earn">1,300</span> Punkte, um die <span rivo-x-data="" rivo-x-text="$store.customer?.current_vip_tier_info?.next_tier?.name">Silver</span>-Stufe zu erreichen.',
      account_dashboard_vip_tiers_progress_completed_subtitle: 'Glückwunsch! Du hast die höchste Stufe erreicht.'
    },

    earning_rules: {
      '315652': { title: 'Bestellung aufgeben',      desc: 'Cashback für jeden ausgegebenen Euro' },
      '315653': { title: 'Geburtstag feiern',        desc: '500 Punkte' },
      '315674': { title: 'Produktbewertung schreiben', desc: '250 Punkte' },
      '315675': { title: 'Auf Instagram folgen',     desc: '200 Punkte' },
      '577595': { title: 'Empfehlung abschließen',   desc: 'Punkte aus Empfehlungskampagne' }
    },

    rewards: {
      '373706': { name: '5 € Rabattgutschein',  description: '500 Punkte' },
      '373707': { name: '10 € Rabattgutschein', description: '1.000 Punkte' },
      '373708': { name: '20 € Rabattgutschein', description: '2.000 Punkte' },
      '433394': { name: '50 € Rabattgutschein', description: '5.000 Punkte' }
    },

    perks: {
      'Unlock by spending':              'Durch Einkauf freischalten',
      'Additional offers and discounts': 'Zusätzliche Angebote und Rabatte',
      'Birthday rewards':                'Geburtstagsprämien',
      'Free shipping':                   'Kostenloser Versand',
      'Early access to launches':        'Früher Zugang zu Neuheiten',
      'Double points events':            'Doppelpunkte-Events',
      'Exclusive event invitations':     'Exklusive Event-Einladungen'
    },

    perk_values: {
      'Yes':                          'Ja',
      '–':                            '–',
      'Orders over 79€':              'Bestellungen über 79 €',
      'Orders over 59€':              'Bestellungen über 59 €',
      'Free shipping on everything':  'Kostenloser Versand auf alles',
      '500 points':                   '500 Punkte',
      '1000 points':                  '1000 Punkte'
    },

    'static': {
      'Your Activity':                          'Deine Aktivität',
      'Activity':                               'Aktivität',
      'Points':                                 'Punkte',
      'Date':                                   'Datum',
      'No activity yet':                        'Noch keine Aktivität',
      'Earn more rewards':                      'Mehr Prämien sammeln',
      'Use your rewards':                       'Prämien einlösen',
      'Use your previously redeemed rewards:':  'Verwende deine bereits eingelösten Prämien:',
      'VIP Tier Status':                        'VIP-Status'
    }
  };
})();
